export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_5120000-c3e2e0c1e4b058ec22b062e364c4b3c3.avif";